import React, { useState } from 'react'; 
import './FilledInput.css';
import tooltipIcon from '../assets/tooltip.svg';
import securityIcon from '../assets/security.svg';

interface FilledInputProps {
    label: string;
    id: string;
    placeholder?: string;
    errorMessage?: string;
    helperText?: string;
    validate?: (value: string) => string | null; // Validation function
    inputChange?: (e: any) => void;
    tooltip?: string; // Tooltip text for icons
  }
  
  const FilledInput: React.FC<FilledInputProps> = ({
    label,
    id,
    placeholder = '',
    errorMessage,
    helperText,
    validate,
    tooltip,
    inputChange,
  }) => {
    const [value, setValue] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [showTooltip, setShowTooltip] = useState(false);
  
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if(inputChange){
        inputChange(e);
      }
      const newValue = e.target.value;
      setValue(newValue);
    };
  
    const handleBlur = () => {
      if (validate && value.trim() !== '') {
        setError(validate(value));
      }
    };
  
    return (
      <div className={`input-wrapper ${error || errorMessage ? 'error' : ''}`}>
        <input
          type="text"
          id={id}
          className="filled-input"
          placeholder=" "
          value={value}
          onChange={handleChange}
          onBlur={handleBlur} // Validate on blur
        />
        <label htmlFor={label} className="filled-label">
          {label}
        </label>
        
        {tooltip && (
          <div
            className="tooltip-icon"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
         <img src={tooltip && tooltip !== ' ' ? tooltipIcon : securityIcon} alt="info" className="info-icon" />
         {tooltip && tooltip !== ' ' && showTooltip && <div className="tooltip-message">{tooltip}</div>}
          </div>
        )}
  
        {/* Error or Helper Text */}
        {(error || errorMessage) && <p className="filled-error-text">{error || errorMessage}</p>}
        {!error && !errorMessage && helperText && <p className="filled-helper-text">{helperText}</p>}
      </div>
    );
  };

export default FilledInput;